import { FaqContainerContent } from '@/types/faq-container.types'
import {
  BankIdContent,
  HeroContent,
  Link,
  Paragraph
} from '@/types/common.types'
import { CfAnslPageLanding } from '@/types/ansl-space/types/cf-ansl-page-landing'
import { Entry } from 'contentful'

export interface LandlordPageContent extends HeroContent {
  paragraphs: Paragraph[];
  pebbleImage: string;
  products: FaqContainerContent[];
  links: Link[];
  contactDetails: string;
  contentful: Entry<CfAnslPageLanding>;
}

interface AfterFormSubmissionContent {
  title: string;
  information: string;
  description: string;
}

interface OrderPageBankIdContent extends BankIdContent {
  authenticationTitle: string;
  authenticationDescription: string;
}

interface LandlordOrderFormContent extends HeroContent {
  propertyText: string;
}

export interface LandlordOrderContent {
  authentication: OrderPageBankIdContent;
  order: LandlordOrderFormContent;
  thankYou: AfterFormSubmissionContent;
  addressListUrl: string | undefined;
}

export enum ContactFormProperties {
  CaseReason = 'caseReason',
  Description = 'description',
  Attachments = 'attachments',
  FullName = 'fullName',
  CompanyCode = 'companyCode',
  CompanyName = 'companyName',
  PhoneNumber = 'phoneNumber',
  EmailAddress = 'emailAddress',
  KoNumber = 'koNumber',
  PreferredContactForm = 'preferredContactForm'
}

export interface ContactFormCaseReason {
  id: string;
  name: string;
}

export interface ContactFormCaseReasonTransformed {
  id: string;
  name: string;
  value: string;
  label: string;
}

export interface ContactFormRequest {
  [ContactFormProperties.CaseReason]: string;
  [ContactFormProperties.Description]: string;
  [ContactFormProperties.Attachments]: File[];
  [ContactFormProperties.EmailAddress]: string;
  [ContactFormProperties.PhoneNumber]: string;
  [ContactFormProperties.CompanyCode]: string;
  [ContactFormProperties.KoNumber]: string;
  [ContactFormProperties.PreferredContactForm]: string;
}

export const CONTACT_FORM_VALIDATION_MESSAGES: Record<string, string> = {
  [ContactFormProperties.CaseReason]: 'Vänligen välj ett ärende',
  [ContactFormProperties.Description]: 'Vänligen beskriv ditt ärende',
  [ContactFormProperties.Attachments]: 'Bifogad fil överstiger maximal filstorlek (25 MB)',
  [ContactFormProperties.FullName]: 'Vänligen ange fullständigt namn',
  [ContactFormProperties.CompanyCode]: 'Organisationsnumret hittades inte. Vänligen kontrollera att det stämmer och försök igen',
  [ContactFormProperties.CompanyName]: 'Vänligen fyll i detta fält',
  [ContactFormProperties.PhoneNumber]: 'Vänligen ange telefonnummer med landsnummer ex. +46',
  [ContactFormProperties.EmailAddress]: 'Vänligen ange epost i rätt format'
}

export enum ParsedAddress {
  RowIndex = 'rowIndex',
  Street = 'street',
  StreetNumber = 'streetNumber',
  City = 'city',
  ApartmentNumber = 'apartmentNumber',
  Entrance = 'entrance',
  FloorPlan = 'floorPlan',
  TenantsName = 'tenantsName',
  TenantsPhone = 'tenantsPhone',
  SwitchLocation = 'switchLocation'
}

export const caseReasonMappedNames: Record<string, string> = {
  1: 'Avtalsfrågor',
  2: 'Fakturafrågor',
  3: 'Felanmälan',
  4: 'Leveransfrågor',
  5: 'Ny kontaktperson'
}
